"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmazonPaymentType = void 0;
const path = require('path');
const LABEL = 'Amazon payment type';
class AmazonPaymentType {
    constructor() {
        this.indexname = 'amazonPay';
        this.label = LABEL;
        this.vueJsComponent = 'amazon-payment-type';
        this.configurationComponentAssets = [
            {
                id: 'amazon-payment-type_script',
                tag: 'script',
                attributes: {
                    type: 'text/javascript'
                },
                content: path.join(__dirname, '../../dist/amazon-settings.js')
            },
            {
                id: 'amazon-payment-type_style',
                tag: 'style',
                content: path.join(__dirname, '../../dist/css/app.css')
            },
            {
                id: 'material-icons',
                tag: 'link',
                attributes: {
                    href: 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons',
                    rel: 'stylesheet'
                }
            }
        ];
        this.configurationComponentTag = '<amazon-settings></amazon-settings>';
        this.useOnBasket = true;
    }
    static getLabel() {
        return LABEL;
    }
}
exports.AmazonPaymentType = AmazonPaymentType;
//# sourceMappingURL=amazon-payment-type-config.js.map